import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { loadTheme } from '@fluentui/react';
import App from "./App";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import '@charm-ux/cui/dist/themes/cui/selector-theme.css'
import '@charm-ux/cui/dist/themes/cui/utility-classes.css'
 
// MSAL imports
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";

// DOME to OPP Redirect - TEMPORARY (remove after transition period)
import { DomeToOppRedirect } from "./DomeToOppRedirect";

// Allowed tenant IDs
const allowedTenants = [
    "72f988bf-86f1-41af-91ab-2d7cd011db47"
];

// Register service worker and force update stale versions
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
        .then(registration => {
          console.log('Service Worker registered:', registration);
          registration.update();
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
    });
}
export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
    // Register event callback BEFORE handleRedirectPromise so we catch LOGIN_SUCCESS
    msalInstance.addEventCallback((event: EventMessage) => {
        if ((event.eventType === EventType.LOGIN_SUCCESS && event.payload) || 
            (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload)) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    msalInstance.handleRedirectPromise()
        .then((tokenResponse) => {
            if (!tokenResponse) {
                const accounts = msalInstance.getAllAccounts();
                if (accounts.length === 0) {
                    // No user signed in, redirect to login
                    return msalInstance.loginRedirect({
                        scopes: ["User.Read"]
                    });
                } else if (!msalInstance.getActiveAccount()) {
                    // Already signed in but no active account set
                    msalInstance.setActiveAccount(accounts[0]);
                }
            } else {
                const idTokenClaims = tokenResponse.idTokenClaims as { tid?: string }; // Access token claims
                const tenantId = idTokenClaims.tid;

                // Validate the tenant ID
                if (!tenantId || !allowedTenants.includes(tenantId)) {
                    console.error("Unauthorized tenant");
                    return msalInstance.logoutRedirect(); // Log out unauthorized tenants
                } else {
                    console.log(`Authorized tenant: ${tenantId}`);
                    // Ensure active account is set after redirect
                    msalInstance.setActiveAccount(tokenResponse.account);
                }
            }

            const root = ReactDOM.createRoot(
              document.getElementById('root') as HTMLElement
            );
            root.render(
                <DomeToOppRedirect>
                    <Router>
                        <ThemeContextProvider>
                          <NotificationProvider>
                            <MsalProvider instance={msalInstance}>
                                <App />
                            </MsalProvider>
                          </NotificationProvider>
                        </ThemeContextProvider>
                    </Router>
                </DomeToOppRedirect>
            );
        })
        .catch(err => {
            console.error("Error during authentication: ", err);
            // If redirect failed due to stale interaction state (e.g., expired nonce/state
            // after browser was idle for days), clear MSAL cache and re-login cleanly.
            msalInstance.clearCache();
            msalInstance.loginRedirect({
                scopes: ["User.Read"],
                prompt: "select_account"
            });
        });
});
